<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/promotion-tools/landing-pages-pools'">Pools management</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add pool</span>
      } @else {
        <span class="fs-5 fw-bold mb-0">Edit pool</span>
      }
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row g-3">
          <div class="col-4">
            <label class="form-label">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
              <input type="text" class="form-control" placeholder="Name" formControlName="name">
            </div>
          </div>

          <div class="col-4">
            <label class="form-label">Identifier (Ad Server value for &pool=)</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
              <input type="text" class="form-control" placeholder="Identifier" formControlName="identifier">
            </div>
          </div>

          <div class="col-4">
            <label class="form-label">Type</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box"></i></span>
              <select id="pool" class="form-select" formControlName="typeId">
                <option [ngValue]="null" disabled>Select type</option>
                @for (type of types; track type.id) {
                  <option [ngValue]="type.id">{{ type }}</option>
                }
              </select>
            </div>
          </div>
        </div>

        <div class="row g-3 mt-1">
          <div class="col-4">
            <label class="form-label">Mode</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-sliders"></i></span>
              <select id="pool" class="form-select" formControlName="mode">
                <option [ngValue]="PoolMode.RANDOM">Random</option>
                <option [ngValue]="PoolMode.ORDERED_CAPPING">Ordered capping</option>
              </select>
            </div>
          </div>

          @if (isCappingMode()) {
            <div class="col-4">
              <label class="form-label">Capping count (0 = disabled)</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
                <input type="number" min="0" class="form-control" formControlName="cappingCount">
              </div>
            </div>

            <div class="col-4">
              <label class="form-label">Capping duration in minutes (0 = disabled)</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
                <input type="number" min="0" class="form-control" formControlName="cappingDuration">
              </div>
            </div>
          }
        </div>

        <div class="row g-3 mt-1">
          <div class="d-flex justify-content-end">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="enabled" formControlName="enabled">
              <label class="form-check-label" for="enabled">Enabled</label>
            </div>
          </div>
        </div>

        <div
          class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-5 mb-1">
          <h2 class="fw-bold fs-6 mb-0">Promotion links ({{ pool?.poolLandingPages?.length }})</h2>
        </div>

        <div class="row mt-2">
          <div class="col-4">
            <div class="landing-page-search" (click)="landingPageSearchClick()">
              <div class="d-flex position-relative">
                <input type="text" class="form-control" [(ngModel)]="landingPageQuery" (ngModelChange)="search()"
                       [ngModelOptions]="{standalone: true}" placeholder="Search promotion links (name or ID)"
                       (focus)="focus()">
                <app-element-loader class="loader" *ngIf="searchLoading"></app-element-loader>
              </div>
              <div class="dropdown">
                <ul class="dropdown-input" [ngClass]="{show:searchShow}">
                  <ng-container *ngFor="let landingPage of landingPageResults">
                    <!--                    @if (!isAdded(landingPage)) {-->
                    <li (click)="add(landingPage)" class="d-flex justify-content-between">
                      <span>#{{ landingPage.id }} - {{ landingPage.name }}</span>
                      <i class="bi bi-plus-circle-fill ms-3 add"></i>
                    </li>
                    <!--                    } @else {-->
                    <!--                      <li (click)="remove(landingPage)" class="d-flex justify-content-between">-->
                    <!--                        {{ landingPage }}-->
                    <!--                        <i class="bi bi-dash-circle-fill ms-3 remove"></i>-->
                    <!--                      </li>-->
                    <!--                    }-->
                  </ng-container>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <table class="table table-hover table-striped align-middle">
              <thead>
              <tr>
                @if (isCappingMode()) {
                  <th>Position</th>
                }
                <th>ID</th>
                <th>Name</th>
                <th>Offer</th>
                <th>Parameters</th>
                <th>Weight</th>
                <th>Status</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
                @for (poolLandingPage of pool?.poolLandingPages; track poolLandingPage) {
                  <tr>
                    @if (isCappingMode()) {
                      <td>
                        <div class="d-flex justify-content-between align-items-center">
                          {{ poolLandingPage.position }}
                          <div>
                            <button class="btn btn-sm btn-primary" type="button" (click)="up(poolLandingPage)" [disabled]="$first">
                              <i class="bi bi-arrow-up"></i>
                            </button>
                            <button class="ms-1 btn btn-sm btn-primary" type="button" (click)="down(poolLandingPage)" [disabled]="$last">
                              <i class="bi bi-arrow-down"></i>
                            </button>
                          </div>
                        </div>
                      </td>
                    }
                    <td>
                      {{ poolLandingPage.landingPage?.id }}
                    </td>
                    <td>
                      {{ poolLandingPage.landingPage?.name }}
                    </td>
                    <td>
                      <select class="form-select" [(ngModel)]="poolLandingPage.offerId"
                              [ngModelOptions]="{standalone: true}">
                        <option [ngValue]="null">Use link offer</option>
                        @for (offer of offers; track offer.id) {
                          <option [ngValue]="offer.id">#{{ offer.id }}
                            - {{ offer.name }}
                          </option>
                        }
                      </select>
                    </td>
                    <td>
                      <div class="d-flex justify-content-between">
                        <span>{{ getParameters(poolLandingPage) }}</span>
                        <button class="btn btn-sm btn-outline-primary" type="button"
                                (click)="openParameterForm(poolLandingPage)">
                          <i class="bi bi-pencil me-1"></i>
                        </button>
                      </div>
                    </td>
                    <td>
                      <input type="number" min="0" max="100" [(ngModel)]="poolLandingPage.weight"
                             [ngModelOptions]="{standalone: true}" class="form-control">
                    </td>
                    <td>
                      <app-input-switch [(ngModel)]="poolLandingPage.enabled"
                                        [ngModelOptions]="{standalone: true}"></app-input-switch>
                    </td>
                    <td>
                      <button class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="remove(poolLandingPage)"
                              type="button"><i
                        class="bi bi-trash"></i></button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="text-end mt-5">
          <button type="submit" class="btn btn-primary fw-bold">
            @if (isCreate()) {
              Create
            } @else {
              Update
            }
          </button>
        </div>
      </form>
    </div>
  </div>
}
